'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
export function useCurrentPathSearch() {
  const $ = _c(7);
  const pathname = usePathname() ?? "/";
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.endsWith("/") ? pathname : `${pathname}/`;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams?.toString() || undefined;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      basePath: t0,
      search: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}